<section class="about-banner">
    <div class="container">       
      <div class="row d-flex align-items-center justify-content-center">
        <div class="about-content col-lg-12 mt-5">
          <h1 class="text-white">
            Contact Us
          </h1> 
          <p class="text-white link-nav"><a routerLink="">Home </a>  <span class="lnr lnr-arrow-right"></span>
            <a routerLink="contact_me">Contact Us</a>
          </p>
          <h4 class="site-banner">
            Get in touch with me to make your idea into reality.
          </h4>
        </div>  
      </div>
    </div>
  </section>
  
  <!-- contact -->
  <div class="contact py-sm-5 py-4" id="contact">
    <div class="container py-lg-3">
      <h1 class="heading mb-4">Contact Us</h1>
      <div class="row pt-lg-4">
        <div class="col-lg-5">
          <div class="contact-left">
            <h4 class="about-left-agile mb-4">Contact Information </h4>
            <p class="mb-4">Say Hello to find the best solution of your problem.</p>
            <p><span class="fa fa-map-marker mr-2"></span> Kota, Rajasthan, India.</p>
            <hr>
            <p><span class="fa fa-phone mr-2"></span><a href="tel:9694691051">+91 9694691051</a></p>
            <hr>
            <p><span class="fa fa-envelope mr-2"></span><a routerLink="mailto:nurulhassan2000@gmail.com" class="ml-3">nurulhassan2000@gmail.com</a></p>
          </div>
        </div>
        <div class="col-lg-7 mt-lg-0 mt-5">
          <!-- register form grid -->
          <div class="register-top1">
            <form action="https://script.google.com/macros/s/AKfycbxDq0JjUZi-bz4mtmn6Wk1e1C3Mk9yHuFMVMM6uRunSNPe7Zsc/exec" method="post" id="gform" class="register-way">
              <div class="form-group">
                <div class="row">
                  <div class="col-md-6">
                    <input class="form-control" type="text" placeholder="Enter Your First Name" name="First Name" required="">
                  </div>
                  <div class="col-md-6 mt-md-0 mt-4">
                    <input class="form-control" type="text" placeholder="Enter Your Last Name" name="Last Name" required="">
                  </div>
                </div>
              </div>
              <div class="form-group">
                <div class="row">
                  <div class="col-md-6">
                    <input class="form-control" type="text" placeholder="Enter Mobile Number" name="Mobile" required="">
                  </div>
                  <div class="col-md-6 mt-md-0 mt-4">
                    <input class="form-control" type="email" placeholder="Enter Email Id" name="Email" required="">
                  </div>
                </div>
              </div>
              <div class="form-group">
                <div class="row">
                  <div class="col-md-12">
                    <textarea placeholder="Enter your message here" name="Message" class="form-control"></textarea>
                  </div>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-md-12">
                  <button type="submit" class="btn btn-send btn-block w-100 text-uppercase">Send</button>
                </div>
              </div>
            </form>
          </div>
          <!--  //register form grid ends here -->
        </div>
      </div>
    </div>
  </div>
  <!-- //contact-->
  